import { render, staticRenderFns } from "./ExcessAndSumInsured.vue?vue&type=template&id=c902ceda&"
import script from "./ExcessAndSumInsured.vue?vue&type=script&lang=js&"
export * from "./ExcessAndSumInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports